import React from "react";

const UnPinIconSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#165ABF"
      d="M10 10H4.887c-.71 0-1.066 0-1.249-.145a.667.667 0 01-.25-.522c0-.233.222-.51.666-1.065L5.1 6.959c.087-.108.13-.162.161-.222a.667.667 0 00.06-.17c.09-.445.563-.682.885-.36L10 10z"
    ></path>
    <path
      stroke="#165ABF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.887 10H10m-5.113 0c-.71 0-1.066 0-1.249-.145a.667.667 0 01-.25-.522c0-.233.222-.51.666-1.065L5.1 6.959c.087-.108.13-.162.161-.222a.667.667 0 00.06-.17v0c.09-.445.563-.682.885-.36L10 10m-5.113 0H8M10 10H8m3.947-1.733l-1.046-1.309c-.087-.108-.13-.162-.16-.222a.665.665 0 01-.06-.17c-.014-.066-.014-.135-.014-.274v-1.42c0-.077 0-.115.005-.153a.673.673 0 01.019-.1c.01-.037.024-.072.053-.143l.671-1.68c.197-.49.295-.735.254-.932a.666.666 0 00-.285-.42c-.167-.111-.431-.111-.959-.111H5.576c-.528 0-.792 0-.959.111a.667.667 0 00-.284.42M8 10.001v4.666M2 2.001l12 12"
    ></path>
  </svg>
);

const UnPinIcon = (props) => {
  return <UnPinIconSvg {...props} />;
};

export { UnPinIcon };
